<template>
    <div class="container bot-page">
        <div class="row g-4">
            <div class="col-12 col-lg-3">
                <div class="card profile-card">
                    <div class="card-body">
                        <img :src="$store.state.user.photo" alt="用户头像" class="bot-avatar">
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-9">
                <div class="card bot-list-card">
                    <div class="card-header bot-card-header">
                        <div>
                            <h2>我的Bot</h2>
                            <HowWirterCode>
                                <span class="guide-link">查看 Bot 实现教程</span>
                            </HowWirterCode>
                        </div>
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#add-bot-btn">
                            创建Bot
                        </button>
                    </div>

                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-hover bot-table text-center align-middle">
                                <thead>
                                    <tr>
                                        <th>名称</th>
                                        <th>创建时间</th>
                                        <th>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="bot in bots" :key="bot.id">
                                        <td>{{ bot.title }}</td>
                                        <td>{{ bot.createtime }}</td>
                                        <td>
                                            <button type="button" class="btn btn-secondary btn-sm action-btn"
                                                data-bs-toggle="modal" :data-bs-target="'#update-bot-modal-' + bot.id">
                                                修改
                                            </button>
                                            <button type="button" class="btn btn-danger btn-sm action-btn"
                                                @click="remove_bot(bot)">
                                                删除
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Teleport to="body">
        <div class="modal fade bot-editor-modal" id="add-bot-btn" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">创建Bot</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="add-bot-title" class="form-label">名称</label>
                            <input v-model="botadd.title" type="text" class="form-control" id="add-bot-title"
                                placeholder="请输入Bot名称">
                        </div>
                        <div class="mb-3">
                            <label for="add-bot-description" class="form-label">简介</label>
                            <textarea v-model="botadd.description" class="form-control" id="add-bot-description"
                                rows="3" placeholder="请输入Bot简介"></textarea>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">代码</label>
                            <VAceEditor v-model:value="botadd.content" lang="c_cpp" theme="textmate"
                                class="bot-code-editor" :options="editorOptions" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="error-message">{{ botadd.error_message }}</div>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
                        <button type="button" class="btn btn-primary" @click="add_bot">创建</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-for="bot in bots" :key="'update-bot-modal-' + bot.id" class="modal fade bot-editor-modal"
            :id="'update-bot-modal-' + bot.id" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5">修改Bot</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label :for="'update-bot-title-' + bot.id" class="form-label">名称</label>
                            <input v-model="bot.title" type="text" class="form-control"
                                :id="'update-bot-title-' + bot.id" placeholder="请输入Bot名称">
                        </div>
                        <div class="mb-3">
                            <label :for="'update-bot-description-' + bot.id" class="form-label">简介</label>
                            <textarea v-model="bot.description" class="form-control"
                                :id="'update-bot-description-' + bot.id" rows="3" placeholder="请输入Bot简介"></textarea>
                        </div>
                        <div class="mb-3">
                            <label class="form-label">代码</label>
                            <VAceEditor v-model:value="bot.content" lang="c_cpp" theme="textmate"
                                class="bot-code-editor" :options="editorOptions" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="error-message">{{ bot.error_message }}</div>
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">取消</button>
                        <button type="button" class="btn btn-primary" @click="update_bot(bot)">保存修改</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { reactive, ref } from 'vue';
import $ from 'jquery';
import { useStore } from 'vuex';
import { Modal } from 'bootstrap/dist/js/bootstrap.min.js';
import { VAceEditor } from 'vue3-ace-editor';
import ace from 'ace-builds';

import 'ace-builds/src-noconflict/mode-c_cpp';
import 'ace-builds/src-noconflict/theme-textmate';
import 'ace-builds/src-noconflict/ext-language_tools';

import HowWirterCode from '@/components/HowWirterCode.vue';
import { apiUrl } from '@/config/backend';

export default {
    components: {
        VAceEditor,
        HowWirterCode,
    },

    setup() {
        ace.config.set(
            "basePath",
            "https://cdn.jsdelivr.net/npm/ace-builds@" +
            require('ace-builds').version +
            "/src-noconflict/"
        );

        const store = useStore();
        const bots = ref([]);
        const editorOptions = {
            enableBasicAutocompletion: true,
            enableSnippets: true,
            enableLiveAutocompletion: true,
            fontSize: 18,
            tabSize: 4,
            showPrintMargin: false,
            highlightActiveLine: true,
        };

        const botadd = reactive({
            title: "",
            description: "",
            content: "",
            error_message: "",
        });

        const hideModal = (selector) => {
            const modalElement = document.querySelector(selector);
            if (!modalElement) return;
            const instance = Modal.getInstance(modalElement) || Modal.getOrCreateInstance(modalElement);
            instance.hide();
        };

        const refresh_bots = () => {
            $.ajax({
                url: apiUrl("/api/user/bot/getlist/"),
                type: "get",
                headers: {
                    Authorization: "Bearer " + store.state.user.token,
                },
                success(resp) {
                    bots.value = resp.map(bot => ({
                        ...bot,
                        error_message: "",
                    }));
                }
            });
        };

        refresh_bots();

        const add_bot = () => {
            botadd.error_message = "";
            $.ajax({
                url: apiUrl("/api/user/bot/add/"),
                type: "post",
                data: {
                    title: botadd.title,
                    description: botadd.description,
                    content: botadd.content,
                },
                headers: {
                    Authorization: "Bearer " + store.state.user.token,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        botadd.title = "";
                        botadd.description = "";
                        botadd.content = "";
                        hideModal("#add-bot-btn");
                        refresh_bots();
                    } else {
                        botadd.error_message = resp.error_message;
                    }
                }
            });
        };

        const remove_bot = (bot) => {
            $.ajax({
                url: apiUrl("/api/user/bot/remove/"),
                type: "post",
                data: {
                    bot_id: bot.id,
                },
                headers: {
                    Authorization: "Bearer " + store.state.user.token,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        refresh_bots();
                    }
                }
            });
        };

        const update_bot = (bot) => {
            bot.error_message = "";
            $.ajax({
                url: apiUrl("/api/user/bot/update/"),
                type: "post",
                data: {
                    bot_id: bot.id,
                    title: bot.title,
                    description: bot.description,
                    content: bot.content,
                },
                headers: {
                    Authorization: "Bearer " + store.state.user.token,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        hideModal("#update-bot-modal-" + bot.id);
                        refresh_bots();
                    } else {
                        bot.error_message = resp.error_message;
                    }
                }
            });
        };

        return {
            bots,
            botadd,
            editorOptions,
            add_bot,
            remove_bot,
            update_bot,
        };
    }
};
</script>

<style scoped>
.bot-page {
    padding-top: 20px;
    padding-bottom: 32px;
}

.profile-card,
.bot-list-card {
    margin-top: 0;
}

.bot-avatar {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 10px;
}

.bot-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 20px;
}

.bot-card-header h2 {
    margin: 0;
    font-size: 1.35rem;
    font-weight: 800;
}

.guide-link {
    display: inline-block;
    margin-top: 8px;
    color: var(--app-primary);
    font-weight: 700;
}

.bot-table {
    margin: 0;
    overflow: hidden;
    color: var(--app-text);
    border-radius: 12px;
}

.bot-table thead th {
    color: var(--app-text);
    background: var(--app-surface-muted);
    border-color: var(--app-border);
}

.bot-table tbody td {
    color: var(--app-text);
    background: color-mix(in srgb, var(--app-surface) 94%, transparent);
    border-color: var(--app-border);
}

.bot-table tbody tr:hover td {
    background: var(--app-surface-muted);
}

.action-btn + .action-btn {
    margin-left: 10px;
}

.bot-editor-modal .modal-content {
    overflow: hidden;
}

.bot-editor-modal .modal-body {
    padding: 22px 24px;
}

.bot-code-editor {
    height: 330px;
    border: 1px solid var(--app-border);
    border-radius: 10px;
    overflow: hidden;
}

.error-message {
    margin-right: auto;
    color: #ef4444;
    font-weight: 700;
}

@media (max-width: 768px) {
    .bot-card-header {
        align-items: stretch;
        flex-direction: column;
    }

    .bot-card-header .btn {
        width: 100%;
    }
}
</style>
